import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthServiceUser } from 'src/app/services/auth/auth.service';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
    selector: 'app-error404',
    templateUrl: './error404.component.html',
    styleUrls: ['./error404.component.css'],
    imports: [
        RouterModule,
        LottieComponent
    ]
})
export class Error404Component {

  options: AnimationOptions = {
    path: '/assets/images/lottie/page-erorr.json',
  };

  constructor(private authService: AuthServiceUser, private router: Router) { }

  navigateBtnClick(){
    this.authService.isErrorPageShown = true;
    this.router.navigate(['/']);
  }
  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

}
